// extracted by mini-css-extract-plugin
module.exports = {"mobileViewWrapper":"_3wVNz"};